if (!customElements.get('tab-bundler-slide')) {
    class TabBundlerSlide extends HTMLElement {
        constructor() {
            super();
            this.observerInstance = null; // 存储观察器实例
        }

        connectedCallback() {
            this.initializeObserver();
        }

        disconnectedCallback() {
            // 停止观察以释放资源
            if (this.observerInstance) {
                this.observerInstance.disconnect();
                this.observerInstance = null;
            }
        }

        initializeObserver() {
            const swiperElement = this.closest('.swiper');
            if (swiperElement) {
                const swiperInstance = swiperElement.swiper;

                if (swiperInstance) {
                    // console.log('已找到 Swiper 实例:', swiperInstance);

                    // 创建观察器
                    this.observerInstance = new MutationObserver((mutations) => {
                        mutations.forEach((mutation) => {
                            if (mutation.type === 'childList') {
                                // console.log('子节点发生变化，正在更新 Swiper 的高度...');
                                swiperInstance.update(); // 更新Swiper高度
                            }
                        });
                    });

                    // 开始观察子节点的变化
                    this.observerInstance.observe(this, { childList: true, subtree: true });
                } else {
                    // console.warn('Swiper 实例未定义。');
                }
            } else {
                // console.warn('未找到父级 Swiper 元素。');
            }
        }
    }

    customElements.define('tab-bundler-slide', TabBundlerSlide);
}
